import React from "react"
import VideoItem from "./VideoItem"

const VideoList = ({videos, onVideo}) => {
  const myvids = videos.map((vid) => {
    return <VideoItem key={vid.id.videoId} video={vid} onVideo={onVideo} />
  })

  return <div className="ui relaxed divided list">{myvids}</div>
}
export default VideoList